/**
 * Custom cursor functionality.
 * @author Dayne Coulson-Hoffacker
 */
export default class Cursor {
  /**
   * Constructs a new Cursor instance.
   * @param {Object} options - Options.
   * @param {HTMLElement} options.element - Container.
   */
  constructor (options) {
    this.element = options.element
    this.a = document.queryAll('a')

    // Mouse move functionality
    document.body.addEventListener('mousemove', (event) => {
      this.moveCursor(event)
    })

    // Mouse leave functionality
    document.body.addEventListener('mouseleave', () => {
      this.element.classList.remove('is-visible')
    })

    // Add class on every 'a' element
    this.a.forEach((element) => {
      element.addEventListener('mouseover', () => {
        this.element.classList.add('link-hover')
      })
      element.addEventListener('mousedown', () => {
        this.element.classList.add('clicked')
      })
      element.addEventListener('mouseup', () => {
        this.element.classList.remove('clicked')
      })
      element.addEventListener('mouseout', () => {
        this.element.classList.remove('link-hover')
      })
    })

  }

  moveCursor (event) {
    let x = event.clientX - 5
    let y = event.clientY - 5
    this.element.classList.add('is-visible')
    this.element.setAttribute('style', 'transform: translate3d(' + x + 'px, '+ y + 'px, 0px');
  }

}



// WEBPACK FOOTER //
// ./components/cursor/index.js